import { z } from "zod";
import { ZObjectIdString } from "./accessControlSchema.js";
import { ZReaction } from "./reactionSchema.js";

// Shared embedded comment structure. text contains rich text; plainText supports search and export.
export const ZBaseComment = z.object({
  _id: ZObjectIdString,
  createdBy: ZObjectIdString,
  text: z.string(),
  createdDate: z.string(),
  createdByName: z.string(),
  deleted: z.boolean().default(false),
  plainText: z.string().optional(),
  reactions: ZReaction.array().optional(),
});

export type IBaseComment = z.infer<typeof ZBaseComment>;
